import React, { useState } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Box,
  Container,
  useMediaQuery,
  Button,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { Link, NavLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';

const Header = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [drawerOpen, setDrawerOpen] = useState(false);

  const navItems = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About Us' },
    { path: '/services', label: 'Products' },
    { path: '/advantages', label: 'Adv & Benefits' },
    { path: '/gallery', label: 'Gallery' },
    { path: '/contact', label: 'Contact' },
  ];

  return (
    <AppBar
      position="fixed"
      sx={{
        backgroundColor: '#ffffff',
        color: '#333',
        boxShadow: 'none',
        borderBottom: '1px solid #ddd',
        zIndex: 1200,
      }}
    >
      <Container maxWidth="lg">
        <Toolbar disableGutters sx={{ minHeight: '80px' }}>
          {/* Logo Section */}
          <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center' }}>
            <Link to="/" style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
              <img
                src="/femlogo.png"
                alt="Logo"
                style={{ height: '50px', marginRight: '15px' }}
              />
              <Box>
                <Typography variant="h6" sx={{ fontWeight: '700', color: '#003366', lineHeight: 1.1, letterSpacing: '0.5px' }}>
                  FEM TECH SOLUTION
                </Typography>
                <Typography variant="caption" sx={{ fontSize: '11px', color: '#666', letterSpacing: '2px', textTransform: 'uppercase' }}>
                  Feel free Everyday
                </Typography>
              </Box>
            </Link>
          </Box>

          {/* Desktop Navigation */}
          {!isMobile && (
            <Box sx={{ display: 'flex', gap: 4, alignItems: 'center' }}>
              {navItems.map((item) => (
                <NavLink
                  key={item.label}
                  to={item.path}
                  className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
                  style={{ cursor: 'pointer', paddingBottom: '5px', textDecoration: 'none' }}
                >
                  <Typography
                    variant="h6"
                    sx={{
                      fontSize: '14px',
                      fontWeight: 600,
                      color: '#444',
                      textTransform: 'uppercase',
                      letterSpacing: '0.5px',
                      transition: 'color 0.3s',
                      '&:hover': { color: '#003366' },
                    }}
                  >
                    {item.label}
                  </Typography>
                </NavLink>
              ))}
              <Button
                component={Link}
                to="/contact"
                variant="contained"
                sx={{
                  backgroundColor: '#7e57c2',
                  color: '#fff',
                  borderRadius: '50px',
                  px: 3,
                  py: 1,
                  fontWeight: 'bold',
                  letterSpacing: '1px',
                  textTransform: 'uppercase',
                  fontSize: '13px',
                  boxShadow: '0 4px 10px rgba(126, 87, 194, 0.2)',
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    backgroundColor: '#5e35b1',
                    transform: 'translateY(-2px)',
                    boxShadow: '0 6px 15px rgba(126, 87, 194, 0.3)'
                  }
                }}
              >
                Get a Quote
              </Button>
            </Box>
          )}

          {/* Mobile Menu Icon */}
          {isMobile && (
            <IconButton onClick={() => setDrawerOpen(true)} sx={{ color: '#003366' }}>
              <MenuIcon />
            </IconButton>
          )}

          {/* Mobile Drawer */}
          <Drawer
            anchor="right"
            open={drawerOpen}
            onClose={() => setDrawerOpen(false)}
          >
            <Box
              sx={{ width: 260, pt: 2 }}
              onClick={() => setDrawerOpen(false)}
              onKeyDown={() => setDrawerOpen(false)}
            >
              <List>
                {navItems.map((item) => (
                  <ListItem button key={item.label} sx={{ mb: 1 }}>
                    <Link
                      to={item.path}
                      style={{ width: '100%', textDecoration: 'none' }}
                      onClick={() => setDrawerOpen(false)}
                    >
                      <ListItemText
                        primary={item.label}
                        primaryTypographyProps={{
                          fontSize: '16px',
                          fontWeight: '600',
                          color: '#003366',
                          textTransform: 'uppercase'
                        }}
                      />
                    </Link>
                  </ListItem>
                ))}
                <ListItem sx={{ mt: 2, px: 2 }}>
                  <Button
                    component={Link}
                    to="/contact"
                    variant="contained"
                    fullWidth
                    onClick={() => setDrawerOpen(false)}
                    sx={{
                      backgroundColor: '#7e57c2',
                      color: '#fff',
                      borderRadius: '50px',
                      py: 1.5,
                      fontWeight: 'bold',
                      letterSpacing: '1px',
                      textTransform: 'uppercase',
                      fontSize: '14px'
                    }}
                  >
                    Get a Quote
                  </Button>
                </ListItem>
              </List>
            </Box>
          </Drawer>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Header;
